import { z } from "zod/v4-mini";

import { Schema, cz } from "@/utils/zodUtils";

export type SupportInfo = {
  supportEmail: string;
  supportPhoneNumber: string;
};

export const supportInfoSchema: Schema<SupportInfo> = cz.transform(
  z.object({
    support_mail: z.string(),
    support_phone_number: z.string(),
  }),
  data => ({
    supportEmail: data.support_mail,
    supportPhoneNumber: data.support_phone_number,
  }),
);
